import React from 'react';
import './Avatar.scss';

interface AvatarProps {
    name: string;
    imageUrl?: string;
    size?: number;
}

const Avatar: React.FC<AvatarProps> = ({ name, imageUrl, size = 24 }) => {
    const getInitials = (name: string) => {
        return name
            .split(' ')
            .map((part) => part[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    if (imageUrl) {
        return (
            <img
                src={imageUrl}
                alt={name}
                className="avatar-image"
                style={{ width: size, height: size }}
            />
        );
    }

    return (
        <div
            className="avatar-initials"
            style={{
                width: size,
                height: size,
                fontSize: `${size * 0.4}px`,
            }}
        >
            {getInitials(name)}
        </div>
    );
};

export default Avatar;
